import React from 'react';
import Raven from 'raven-js';

export default class ErrorBoundary extends React.Component {
  componentDidCatch(error, errorInfo) {
    Raven.captureException(error, {
      tags: { error_type: errorInfo }
    });
  }

  render() {
    return this.props.children;
  }
}



// WEBPACK FOOTER //
// ./src/common/withBoundaries.js